import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
// import { Avatar } from "@mui/material";
import UserPlan from './UserPlan'
import { CircularProgress } from '@mui/material'
import UserGdHistory from './UserGdHistory'
import Connection from './Connection'
import UserValuation from './UserValuation'
import Dealmaker from './Dealmaker'
import EMailActivity from './EMailActivity'
import Pitchdeck from './Pitchdeck'
import AIPitchdeck from './AIPitchdeck'
import Jobs from './Jobs'
import getUrlqueries from '../../../../Utils/getUrlqueries'
import Feedbacks from './Feedbacks'
import BrevoEmailActivity from './BrevoEmailActivity'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Button
} from '@mui/material'
import ProfileViews from './ProfileViews'
import MaximumInteractions from './MaximumInteractions'
const returnDate = d => {
  return new Date(d).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })
}

const returnDateOrDash = value => {
  if (!value) return '--'
  const parsedDate = new Date(value)
  if (Number.isNaN(parsedDate.getTime())) return '--'
  return returnDate(parsedDate)
}

const formatUsageLabel = value => {
  if (!value) return '--'

  return value
    .split('_')
    .join(' ')
    .replace(/\b\w/g, char => char.toUpperCase())
}

const SpecificUserActivity = () => {
  const [searchuser, setsearchuser] = useState('')
  const [fetchedusers, setfetchedusers] = useState([])
  const [selectedUserId, setselectedUserId] = useState(null)
  const [plans, setPlans] = useState([])
  const [history, sethistory] = useState([])
  const [connections, setconnections] = useState([])
  const [valuations, setvaluations] = useState([])
  const [deals, setdeals] = useState([])
  const [emaillogs, setemaillogs] = useState([])
  const [brevologs, setbrevologs] = useState([])
  const [pitchdecks, setpitchdecks] = useState([])
  const [aipitchdecks, setaipitchdecks] = useState([])
  const [jobs, setjobs] = useState([])
  const [feedbacks, setfeedbacks] = useState([])
  const [recentlogins, setrecentlogins] = useState([])
  const [profileviewss, setprofileviews] = useState([])
  const [maxinteractions, setmaxinteractions] = useState([])
  const [userToolUsage, setUserToolUsage] = useState({})
  const [spamReportCount, setSpamReportCount] = useState(0)
  const [loader, setloader] = useState(false)
  const userid = getUrlqueries('userid')
  //   const [currentuser, setcurrentuser] = useState(null);
  const getUserById = async () => {
    await axios.get(`/api/admin/userbyid/${userid}`).then(res => {
      if (res.data.success) {
        setselectedUserId(res.data.data)
        setloader(false)
      } else {
        console.log('User not found')
      }
    })
  }
  useEffect(() => {
    if (userid) {
      getUserById()
    }
  }, [userid])
  const fetchUserByName = async () => {
    try {
      // if (searchuser.trim() === "") {
      //   setselectedUserId(null);
      //   setfetchedusers([]);
      //   return;
      // }
      const response = await axios.get(`/api/admin/searchuser?s=${searchuser}`)
      if (response.data.success) {
        setfetchedusers(response.data.data)
      }
    } catch (error) {
      if (error && error.response && error.response.data) {
        toast.error(error.response.data.error)
      }
    }
  }

  useEffect(() => {
    if (searchuser?.trim() != '') fetchUserByName()
    else setfetchedusers([])
  }, [searchuser])
  const fetchPlans = async () => {
    setloader(true)
    await axios({
      method: 'get',
      url: `/api/activity/newplans?userid=${selectedUserId?._id}`
    })
      .then(res => {
        setPlans(res.data.data)
        setloader(false)
        // setCount(res.data.count);
        setsearchuser('')
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }

  const fetchGdHistory = async () => {
    await axios({
      method: 'get',
      url: `/api/activity/gd_history?userid=${selectedUserId?._id}`
    })
      .then(res => {
        sethistory(res.data.data)
        // setCount(res.data.count);
      })
      .catch(err => console.log(err))
  }
  const fetchConnections = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/connectionsofuser?userid=${selectedUserId?._id}`
    })
    setconnections(data.data)
  }
  const fetchvaluation = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/valuationsofuser?userid=${selectedUserId?._id}`
    })
    setvaluations(data.data)
  }
  const fetchdeals = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/dealsofuser?userid=${selectedUserId?._id}`
    })
    setdeals(data.data)
  }
  const fetchEmails = async () => {
    setloader(true)
    await axios({
      method: 'get',
      url: `/api/cronjobs/allemaillogs?email=${selectedUserId?.email}&sorttype=decreaseexpiry`
    })
      .then(res => {
        setemaillogs(res.data.data)
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }
  const fetchBrevoEmails = async () => {
    setloader(true)
    await axios({
      method: 'get',
      url: `/api/cronjobs/allbrevologs?email=${selectedUserId?.email}`
    })
      .then(res => {
        setbrevologs(res.data.data)
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }
  const fetchpitchdecks = async () => {
    setloader(true)
    await axios({
      method: 'get',
      url: `/api/activity/pitchdecksofuser?userid=${selectedUserId?._id}`
    })
      .then(res => {
        setpitchdecks(res.data.data)
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }
  const fetchaipitchdecks = async () => {
    setloader(true)
    await axios({
      method: 'get',
      url: `/api/activity/ai-pitchdecksofuser?userid=${selectedUserId?._id}`
    })
      .then(res => {
        setaipitchdecks(res.data.data)
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }
  const fetchjobs = async () => {
    await axios({
      method: 'get',
      url: `/api/cronjobs/alljobs?userid=${selectedUserId?._id}&sorttype=decreaseexpiry`
    })
      .then(res => {
        setjobs(res.data.data)
      })
      .catch(err => {
        console.log(err)
        setloader(false)
      })
  }
  const fetchfeedbacks = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/feedbacksofuser?userid=${selectedUserId?._id}&email=${selectedUserId?.email}`
    })
    setfeedbacks(data.data)
  }
  const getrecentlogins = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/recentlogincounts/${selectedUserId?._id}`
    })
    if (data.data) setrecentlogins(data.data)
  }
  const getProfileViews = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/profileviews/${selectedUserId?._id}`
    })
    if (data.data) setprofileviews(data.data)
  }
  const getMaxInteractions = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/maxinteractions/${selectedUserId?._id}`
    })
    if (data.data) setmaxinteractions(data.data)
  }
  const getUserUsage = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/user-tool-usage/${selectedUserId?._id}`
    })
    const payload = data?.data?.data
    setUserToolUsage(payload?.tools || {})
  }
  const getSpamReportCount = async () => {
    const { data } = await axios({
      method: 'get',
      url: `/api/activity/spamreportsofuser?userid=${selectedUserId?._id}`
    })
    if (data.success) setSpamReportCount(data.count)
  }

  const userToolUsageGroups = Object.entries(userToolUsage || {}).map(
    ([tool, features]) => ({
      tool,
      features: Object.entries(features || {}).map(([feature, usage]) => ({
        feature,
        count: usage?.count || 0,
        weeklyCount: usage?.weeklyCount || 0,
        firstHitAt: usage?.firstHitAt,
        lastUsedAt: usage?.lastUsedAt,
        weekStart: usage?.weekStart
      }))
    })
  )

  useEffect(() => {
    if (selectedUserId) {
      fetchPlans()
      fetchGdHistory()
      fetchConnections()
      fetchvaluation()
      fetchdeals()
      fetchEmails()
      fetchpitchdecks()
      fetchaipitchdecks()
      fetchjobs()
      fetchfeedbacks()
      getrecentlogins()
      fetchBrevoEmails()
      getProfileViews()
      getMaxInteractions()
      getUserUsage()
      getSpamReportCount()
    }
  }, [selectedUserId])
  const navigate = useNavigate()
  const handleToggleNewsletter = async () => {
    try {
      if (
        !confirm('Are you sure you want to toggle the newsletter subscription?')
      )
        return
      await axios
        .get(`/api/admin/togglenewsletter/${selectedUserId?._id}`)
        .then(res => {
          if (res.data.success) {
            getUserById()
          }
        })
    } catch (error) {
      console.log(error)
    }
  }
  const handleToggleBlock = async block => {
    try {
      if (
        !confirm(
          `Are you sure you want to ${block ? 'unblock' : 'block'} this user?`
        )
      )
        return
      await axios
        .post(`/api/admin/block-user`, {
          id: selectedUserId?._id,
          block: !block
        })
        .then(res => {
          if (res.data.success) {
            getUserById()
          }
        })
    } catch (error) {
      console.log(error)
    }
  }

  const [activityFrom, setActivityFrom] = useState('')
  const [activityTo, setActivityTo] = useState('')
  const [activityUserType, setActivityUserType] = useState('')
  const [activityPlan, setActivityPlan] = useState('')

  const handleGetActivityDownload = async all => {
    let url = '/api/activity/get-activity-log'
    if (!all) {
      url += `?startDate=${activityFrom}&endDate=${activityTo}&userType=${activityUserType}&plan=${activityPlan}`
    }

    window.open(url)
  }

  return (
    <>
      <ToastContainer />
      <div className='plan_root mt-0 pt-0'>
        <div className='d-flex align-items-center justify-content-between plan_dates'>
          <div style={{ position: 'relative' }} className=''>
            <div className='d-flex align-items-end gap-5'>
              <div>
                <p>Search User</p>
                <input
                  style={{ width: '500px', padding: '8px' }}
                  value={searchuser}
                  className='h-40px'
                  onChange={e => setsearchuser(e.target.value)}
                  type='text'
                  placeholder='Get activity by name'
                />
              </div>
              {selectedUserId && (
                <h4 className='pointer' onClick={() => setselectedUserId(null)}>
                  X
                </h4>
              )}
            </div>
            {searchuser.length > 0 && fetchedusers && fetchedusers.length > 0 && (
              <div
                style={{ position: 'absolute', zIndex: 10 }}
                className='mt-2 gd_explore_main_results_block'
              >
                <div style={{ backgroundColor: 'white' }} className='thin_bg '>
                  {fetchedusers.map((v, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        // setselectedUserId(v);
                        navigate(`/admin/user-activity?tab=13&userid=${v?._id}`)
                        setfetchedusers([])
                      }}
                      className='gd_explore_main_result d-flex justify-content-between align-items-center mb-16 pointer'
                    >
                      <div className='d-flex align-items-center px-2 py-1'>
                        <Avatar
                          src={v.avatar}
                          alt={v.name ?? v.firstname}
                          style={{ height: 40, width: 40, zIndex: 5 }}
                        />
                        <div style={{ color: 'black' }} className='ms-3'>
                          <p className='body1 mb-0'>
                            {v.type === 'member'
                              ? `${v.firstname} ${v.lastname}, (${v.type}) `
                              : `${v.name}, (${v.firstname} ${v.lastname}, ${v.type})`}

                            <span className='caption'> {v.email}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {selectedUserId ? (
              <>
                <Box display='flex' gap={3} flexWrap='wrap'>
                  <Card
                    sx={{
                      maxWidth: 400,
                      borderRadius: 3,
                      boxShadow: 3,
                      marginTop: 2
                    }}
                  >
                    <CardContent>
                      <Box display='flex' alignItems='center' gap={2} mb={2}>
                        <Avatar
                          src={selectedUserId.avatar}
                          alt={selectedUserId.name ?? selectedUserId.firstname}
                          sx={{ width: 48, height: 48 }}
                        />
                        <Box>
                          <Typography
                            sx={{ mb: 1, fontWeight: 'bolder' }}
                            variant='h6'
                          >
                            {selectedUserId.name}
                          </Typography>
                          <Typography variant='body2' color='text.secondary'>
                            {selectedUserId.firstname} {selectedUserId.lastname}{' '}
                            ({selectedUserId.type})
                          </Typography>
                        </Box>
                      </Box>

                      <Divider sx={{ my: 2 }} />

                      <Typography variant='body2' gutterBottom>
                        <strong>Email:</strong>
                        {selectedUserId?.email}
                      </Typography>
                      <Typography variant='body2 ' gutterBottom>
                        <strong className='mr-2'>ID:</strong>
                        {selectedUserId?._id}
                      </Typography>

                      <Typography variant='body2' gutterBottom>
                        <strong>Signup:</strong>
                        {returnDate(selectedUserId?.createdAt)}
                      </Typography>
                      <Typography variant='body2' gutterBottom>
                        <strong>Source:</strong>
                        {selectedUserId?.source}
                      </Typography>
                      <Typography variant='body2' gutterBottom>
                        <strong>Last Active:</strong>
                        {returnDate(recentlogins?.lastActiveAt)}
                      </Typography>
                      <Typography variant='body2' gutterBottom>
                        <strong>Last Login:</strong>
                        {returnDate(recentlogins?.lastLogin)}
                      </Typography>
                      <Typography variant='body2' gutterBottom>
                        <strong>Logins since last month:</strong>
                        {recentlogins?.loginsWithinaMonths}
                      </Typography>
                      <Typography variant='body2' gutterBottom>
                        <strong>Total Logins:</strong>{' '}
                        {recentlogins?.loginCount}
                      </Typography>
                      <Typography
                        variant='body2'
                        color={spamReportCount > 0 ? 'error.main' : 'text.secondary'}
                      >
                        <strong className='mr-2'>Marked as Spam by:</strong>
                        {spamReportCount} user{spamReportCount === 1 ? '' : 's'}
                      </Typography>
                    </CardContent>
                  </Card>
                  <Card
                    sx={{ maxWidth: 400, borderRadius: 3, boxShadow: 3, mt: 3 }}
                  >
                    <CardContent>
                      <Typography variant='h6' sx={{ mb: 0.5 }}>
                        Block User
                      </Typography>

                      <Typography
                        variant='body1'
                        color={
                          !selectedUserId?.isBlocked
                            ? 'success.main'
                            : 'error.main'
                        }
                      >
                        {!selectedUserId?.isBlocked ? '' : 'Blocked'}
                      </Typography>

                      <Box mt={1} mb={2}>
                        <Button
                          variant='contained'
                          color={
                            selectedUserId?.isBlocked ? 'error' : 'primary'
                          }
                          onClick={() =>
                            handleToggleBlock(selectedUserId?.isBlocked)
                          }
                        >
                          {selectedUserId?.isBlocked ? 'Unblock' : 'Block'}
                        </Button>
                      </Box>
                      <Typography variant='h6' sx={{ mb: 1 }}>
                        Newsletter Subscription
                      </Typography>

                      <Typography
                        variant='body1'
                        color={
                          selectedUserId?.newsletter
                            ? 'success.main'
                            : 'error.main'
                        }
                      >
                        {selectedUserId?.newsletter
                          ? 'Subscribed'
                          : 'Not Subscribed'}
                      </Typography>

                      <Box mt={2}>
                        <Button
                          variant='contained'
                          color={
                            selectedUserId?.newsletter ? 'error' : 'primary'
                          }
                          onClick={() => handleToggleNewsletter()}
                        >
                          {selectedUserId?.newsletter
                            ? 'Unsubscribe'
                            : 'Subscribe'}
                        </Button>
                      </Box>
                      <Box mt={2}>
                        <Typography
                          display='block'
                          variant='body2 '
                          gutterBottom
                        >
                          <strong className='mr-2'>Is 2FA set?:</strong>
                          <span
                            style={
                              selectedUserId?.is2fAuth &&
                              selectedUserId?.is2fAuth === true
                                ? { color: 'green' }
                                : { color: 'red' }
                            }
                          >
                            {selectedUserId?.is2fAuth &&
                            selectedUserId?.is2fAuth === true
                              ? `Yes (${
                                  selectedUserId?.default2FAuthChannel
                                    ? selectedUserId?.default2FAuthChannel
                                    : 'sms'
                                })`
                              : 'Not Yet'}
                          </span>
                        </Typography>
                        <Typography
                          display='block'
                          variant='body2 '
                          gutterBottom
                        >
                          <strong className='mr-2'>Phone Number:</strong>
                          {selectedUserId?.phone}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
                <Box
                  sx={{
                    mt: 3,
                    width: '100%'
                  }}
                >
                  <Typography variant='h6' sx={{ fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
                    User Tool Free Usage
                  </Typography>
                  <Card sx={{ borderRadius: 3, boxShadow: 2, mt: 2 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Box sx={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f8fafc' }}>
                              <th
                                style={{
                                  textAlign: 'left',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Tool
                              </th>
                              <th
                                style={{
                                  textAlign: 'left',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Feature
                              </th>
                              <th
                                style={{
                                  textAlign: 'center',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Total Hit Count
                              </th>
                              <th
                                style={{
                                  textAlign: 'center',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Weekly Hit Count
                              </th>
                              <th
                                style={{
                                  textAlign: 'left',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                First Hit At
                              </th>
                              <th
                                style={{
                                  textAlign: 'left',
                                  padding: '14px 16px',
                                  borderBottom: '1px solid #e2e8f0',
                                  fontSize: '13px',
                                  color: '#475569',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                Last Used At
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {userToolUsageGroups.length ? (
                              userToolUsageGroups.map(group => (
                                <React.Fragment key={group.tool}>
                                  <tr style={{ backgroundColor: '#f8fafc' }}>
                                    <td
                                      colSpan='7'
                                      style={{
                                        padding: '12px 16px',
                                        borderBottom: '1px solid #e2e8f0',
                                        borderTop: '1px solid #e2e8f0',
                                        color: '#0f172a',
                                        fontWeight: 700,
                                        fontSize: '15px'
                                      }}
                                    >
                                      {formatUsageLabel(group.tool)}
                                    </td>
                                  </tr>
                                  {group.features.map(row => (
                                    <tr key={`${group.tool}-${row.feature}`}>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#64748b',
                                          verticalAlign: 'top',
                                          fontWeight: 600
                                        }}
                                      >
                                        {/* {formatUsageLabel(group.tool)} */}
                                      </td>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#0f172a',
                                          verticalAlign: 'top',
                                          fontWeight: 600
                                        }}
                                      >
                                        {formatUsageLabel(row.feature)}
                                      </td>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#0f172a',
                                          textAlign: 'center',
                                          verticalAlign: 'top',
                                          fontWeight: 600
                                        }}
                                      >
                                        {row.count}
                                      </td>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#0f172a',
                                          textAlign: 'center',
                                          verticalAlign: 'top',
                                          fontWeight: 600
                                        }}
                                      >
                                        {row.weeklyCount}
                                      </td>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#475569',
                                          verticalAlign: 'top',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {returnDateOrDash(row.firstHitAt)}
                                      </td>
                                      <td
                                        style={{
                                          padding: '14px 16px',
                                          borderBottom: '1px solid #f1f5f9',
                                          color: '#475569',
                                          verticalAlign: 'top',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {returnDateOrDash(row.lastUsedAt)}
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan='7'
                                  style={{
                                    padding: '18px 16px',
                                    textAlign: 'center',
                                    color: '#64748b'
                                  }}
                                >
                                  No tool usage found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </>
            ) : (
              <div>
                <h4 className='mt-5'>Download User Activity</h4>
                <div className='d-flex flex-column align-items-center'>
                  <button
                    onClick={() => handleGetActivityDownload(true)}
                    className='small_CTA_btn'
                  >
                    Download All Activity
                  </button>
                  <p className='mt-3'>OR</p>
                  <div className='d-flex align-items-center gap-4'>
                    <div>
                      <p>From</p>
                      <input
                        type='date'
                        value={activityFrom}
                        onChange={e => setActivityFrom(e.target.value)}
                      />
                    </div>
                    <div>
                      <p>To</p>
                      <input
                        type='date'
                        value={activityTo}
                        onChange={e => setActivityTo(e.target.value)}
                      />
                    </div>
                    <div>
                      <p>User Type</p>
                      <select
                        placeholder='Type'
                        className='h-40px w-120px'
                        value={activityUserType}
                        onChange={e => setActivityUserType(e.target.value)}
                      >
                        <option value=''>All</option>
                        <option value='startup'>Startup</option>
                        <option value='investor'>Investor</option>
                        <option value='fundcompany'>Fund Company</option>
                        <option value='corporate'>Corporate</option>
                      </select>
                    </div>
                    <div>
                      <p>Plan</p>
                      <select
                        placeholder='Type'
                        className='h-40px w-120px'
                        value={activityPlan}
                        onChange={e => setActivityPlan(e.target.value)}
                      >
                        <option value=''>All</option>
                        <option value='Free'>Free</option>
                        <option value='Basic'>Basic</option>
                        <option value='Premium'>Premium</option>
                        <option value='Freemium'>Freemium</option>
                      </select>
                    </div>
                    <button
                      className='small_CTA_btn'
                      onClick={() => handleGetActivityDownload(false)}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {loader && <CircularProgress />}
        {selectedUserId && (
          <>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              User Plan
            </Typography>
            <div className='activity_block'>
              <UserPlan plans={plans} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Gd History ({history.length})
            </Typography>
            <div className='activity_block'>
              <UserGdHistory history={history} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Connection Activity ({connections.length})
            </Typography>
            <div className='activity_block w_100'>
              <Connection activity={connections} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Pitchdeck Activity ({pitchdecks.length})
            </Typography>
            <div className='activity_block'>
              <Pitchdeck activity={pitchdecks} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              AI Pitchdeck Activity ({aipitchdecks.length})
            </Typography>
            <div className='activity_block'>
              <AIPitchdeck activity={aipitchdecks} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Valuation Activity ({valuations.length})
            </Typography>
            <div className='activity_block'>
              <UserValuation activity={valuations} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Dealmaker Activity ({deals.length}){' '}
            </Typography>
            <div className='activity_block'>
              <Dealmaker activity={deals} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Profile Interactions ({profileviewss.length})
            </Typography>
            <div className='activity_block'>
              <ProfileViews activity={profileviewss} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Maximum Interactions ({maxinteractions.length})
            </Typography>
            <div className='activity_block'>
              <MaximumInteractions activity={maxinteractions} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Brevo Email Activity ({brevologs.length})
            </Typography>
            <div className='activity_block'>
              <BrevoEmailActivity plans={brevologs} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              AWS Email Activity ({emaillogs.length})
            </Typography>
            <div className='activity_block'>
              <EMailActivity plans={emaillogs} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Scheduled Emails ({jobs.length}){' '}
            </Typography>
            <div className='activity_block'>
              <Jobs plans={jobs} />
            </div>
            <hr />
            <Typography
              variant='h6'
              sx={{
                mt: 2,
                fontWeight: 'bold',
                color: 'text.primary'
              }}
            >
              Platform Feedbacks ({feedbacks.length})
            </Typography>
            <div className='activity_block'>
              <Feedbacks activity={feedbacks} />
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default SpecificUserActivity
